import { IconName } from '../../../../../React/Common/Components/Icon'
import { MainMenuApp } from '../../../../../NonReact/constants/AppMenuConstants'
import { Page } from '../../../../../NonReact/constants/Components/Page'

export enum RouteID {
    ADMIN = 'admin',
    STATUS = 'status',
    LICENCES = 'licences',
    LICENCE_MANAGEMENT = 'licenceManagement',
    TELSYS = 'telsys',
    USERS = 'users',
    CME = 'cme',
    AGENT = 'agent',
    PARTITION = 'partitions',
    DEVICE = 'device',
    CODE = 'code',
    RECORDING = 'recording',
    MESSAGES = 'messages',
    DATABASE = 'database',
    DIRECTORY = 'directory',
    PRESENCE = 'presence',
    INSIGHTS = 'insights',
    AUTH = 'auth',
    FORGOT_PASSWORD = 'forgotPassword',
    CHANGE_PASSWORD = 'changePassword',
    CHANGE_LANGUAGE = 'changeLanguage',
    RESET_PASSWORD = 'resetPassword',
    MFA = 'mfa',
    TERMS_AND_CONDITIONS = 'termsAndConditions',
    COOKIE_POLICY = 'cookiePolicy',
    PRIVACY_POLICY = 'privacyPolicy',
    REPORTING_PORTAL = 'reportingPortal',
    TEAMS_AUTH = 'teamsAuth',
    WEBEX_AUTH = 'webexAuth',
    CRM_INTEGRATION = 'crmIntegration',
    CLIENT_CONFIGURATION = 'clientConfiguration',
    CHANGE_USER_AGENT = 'changeUserAgent',
    ADMIN_CONTROL = 'adminControl',
    CXSCORE = 'cxScore',
    AUDIT_TRAIL = 'auditTrail',
    LOG_MANAGEMENT = 'logManagement',
    LOGGING_SETTINGS = 'loggingSettings',
    TEL_MODULE_STATUS = 'telModuleStatus',
    QUEUE_MANAGEMENT = 'queueManagement'
}

export enum ChildRouteID {
    CXSCORE_OVERVIEW = 'overview',
    CXSCORE_CX_SCORE = 'cx-score',
    CXSCORE_CALLS = 'calls'
}

export type AppMenuEntry = {
    enabled: boolean
    title: string
    icon: IconName
    menu: MainMenuApp
    pages?: RouteID[]
    oldPages?: Page[]
}

/**
 * Mode signalled by the new-UI parent window when the CCS is embedded inside its iframe.
 * `legacy`  — the parent is showing the legacy CCS UI; the CCS header must be hidden so
 *             the parent's own chrome wraps the page.
 * `portal`  — the parent is showing the new Fusion portal; the CCS header is suppressed
 *             entirely and the page renders content-only.
 */
export type FusionMode = 'legacy' | 'portal'

/**
 * Augmented Window shape exposing the {@code __akixiFusionMode} property that the new-UI
 * parent sets on its own window object before the iframe loads. Captured at module-load
 * time inside {@code Header.tsx} so the value is available before any async settings fetch.
 */
export type FusionParentWindow = Window & {
    __akixiFusionMode?: FusionMode
}

/**
 * Response shape of {@code GET /CCS/API/v1/auth/new-ui-sso}. The CCS endpoint exchanges the
 * current authenticated session for a facade session token; the front-end then redirects
 * the browser to the new UI with that token in the URL.
 */
export type NewUISsoResponse = {
    session_token: string
    expires_in: number
}
